import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

const RISK_LABEL_FAILURE = 'Failure';
const RISK_LABEL_CRITICAL = 'Critical';
const RISK_LABEL_HIGH = 'High';
const RISK_LABEL_MEDIUM = 'Medium';
const RISK_LABEL_LOW = 'Low';
const RISK_LABEL_UNKNOWN = 'N/A';

const RISK_FAILURE = 'failure';
const RISK_CRITICAL = 'critical';
const RISK_HIGH = 'high';
const RISK_MED = 'medium';
const RISK_LOW = 'low';
const RISK_UNKNOWN = 'unknown';

@Component({
  selector: 'risk-heat-bar',
  templateUrl: './risk-heat-bar.html',
  styleUrls: ['./risk-heat-bar.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RiskHeatBarComponent {
  @Input() risk: string;
  @Input() tooltip: string;
  @Input() cssClass = '';
  @Input() version = '';

  get template(): string {
    return `<div class="tooltip risk-heat-bar-tooltip ${this.cssClass}"><div class="tooltip-inner"></div></div>`;
  }

  get riskNormalized(): string {
    if (!this.risk || typeof this.risk !== 'string') return RISK_UNKNOWN;

    const r = this.risk.toLowerCase();

    if (r === 'failure' || r === 'f') {
      return RISK_FAILURE;
    }

    if (r === 'critical' || r === 'c') {
      return RISK_CRITICAL;
    }

    if (r === 'high' || r === 'h') {
      return RISK_HIGH;
    }

    if (r === 'medium' || r === 'med' || r === 'm') {
      return RISK_MED;
    }

    if (r === 'low' || r === 'l') {
      return RISK_LOW;
    }

    return RISK_UNKNOWN;
  }

  get riskLabel(): string {
    if (!this.risk || typeof this.risk !== 'string') return RISK_LABEL_UNKNOWN;

    const r = this.risk.toLowerCase();

    if (r === 'failure' || r === 'f') {
      return RISK_LABEL_FAILURE;
    }

    if (r === 'critical' || r === 'c') {
      return RISK_LABEL_CRITICAL;
    }

    if (r === 'high' || r === 'h') {
      return RISK_LABEL_HIGH;
    }

    if (r === 'medium' || r === 'med' || r === 'm') {
      return RISK_LABEL_MEDIUM;
    }

    if (r === 'low' || r === 'l') {
      return RISK_LABEL_LOW;
    }

    return RISK_LABEL_UNKNOWN;
  }
}
